import { Reducer } from "redux";

import { LogoutResponse } from "../models/Api/Logout";
import { AllLogoutDispatchTypes } from "../models/DispatchTypes/Logout";
import { LogoutActionDispatchTypes } from "../constants/Logout";

const initialState: LogoutResponse = {
  loading: false,
  response: {
    message: "",
  },
};

const LogoutReducer: Reducer<LogoutResponse, AllLogoutDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case LogoutActionDispatchTypes.LOGOUT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case LogoutActionDispatchTypes.LOGOUT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case LogoutActionDispatchTypes.LOGOUT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.response,
      };
    }
  }
  return state;
};

export default LogoutReducer;
